// Ícone obtido em heroicons.dev (https://heroicons.dev/)

import React from "react";

export function PlayIcon(props) {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" {...props}>
        <path
            d="M8.28125 5.21875C7.8125 4.9375 7.21875 4.9375 6.75 5.21875C6.28125 5.46875 6 5.96875 6 6.5V17.5C6 18.0625 6.28125 18.5625 6.75 18.8125C7.21875 19.0938 7.8125 19.0625 8.28125 18.7812L17.2812 13.2812C17.7188 13.0312 18 12.5312 18 12C18 11.5 17.7188 11 17.2812 10.7188L8.28125 5.21875Z"/>
      </svg>
  );
}
